import React from 'react';


export class Select extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            color: 'main',
            values: {},
            value: null,
            required: false,
            onChange: (event) => {},
            ...this.props
        };
    }

    renderOptions = () => {
        let options = [];

        let labels = [];
        let values = [];

        if (Array.isArray(this.state.values)) {
            labels = this.state.values;
            values = this.state.values;
        } else {
            labels = Object.values(this.state.values);
            values = Object.keys(this.state.values);
        }

        if (!this.state.required) {
            options.push(<option key={-1}>&nbsp;</option>);
        }

        values.forEach(function(value, x) {
            options.push(<option value={value} key={x}>{labels[x]}</option>);
        });

        return options;
    }

    render() {
        return (
            <select
                className={'imd-form-control imd-border-bottom-color-' + this.state.color + ' imd-text-' + this.state.color}
                value={this.state.value}
                onChange={(event) => this.state.onChange(event)}
            >
                {this.renderOptions()}
            </select>
        );
    }
}
